// Users — the roster view at /admin/entitlements/users. Read-only: shows who's
// on the tenant, their entitled features, and token usage this month. Grants
// still happen on the Entitlements/SKU view — this page has no write actions.
import { useEffect } from "react";
import { inject, observer } from "mobx-react";

const formatTokens = (monthly_tokens) => {
  if (!monthly_tokens) return "— (usage unavailable)";
  return `${monthly_tokens.input_tokens.toLocaleString()} in / ${monthly_tokens.output_tokens.toLocaleString()} out`;
};

const Users = ({ usersStore }) => {
  useEffect(() => { usersStore.load(); }, [usersStore]);

  return (
    <>
      <div className="page-hero">
        <div>
          <div className="adminEnt-eyebrow section-eyebrow">Roster</div>
          <h1 className="serif hero-display">Users</h1>
          <p className="lede">Who's on this tenant, what they're entitled to, and tokens used this month.</p>
        </div>
      </div>
      {usersStore.error && <div className="err">Error: {usersStore.error}</div>}
      {usersStore.loading && <div className="empty">Loading...</div>}
      {!usersStore.loading && !usersStore.error && (
        <table className="adminEnt-usersTable">
          <thead>
            <tr>
              <th>User</th>
              <th>Features</th>
              <th>Tokens this month</th>
            </tr>
          </thead>
          <tbody>
            {usersStore.users.map((u) => (
              <tr key={u.user_id}>
                <td>{u.user_id}</td>
                <td>
                  {u.features.map((f) => (
                    <span key={f} className="chip">{f}</span>
                  ))}
                </td>
                <td>{formatTokens(u.monthly_tokens)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default inject("usersStore")(observer(Users));
